<template>
  <div></div>
</template>
<script>
export default {
  name: 'blank',
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.query) {
        vm.$router.replace({
          path: from.path,
          query: from.query
        })
      } else if(from.params) {
        vm.$router.replace({
          path: from.path,
          params: from.params
        })
      } else {
        vm.$router.replace({
          path: from.path
        })
      }
    });
  }
}
</script>
